import { validateCalendars } from '../common'
const bodyScrollLock = require('body-scroll-lock');
const clearAllBodyScrollLocks = bodyScrollLock.clearAllBodyScrollLocks;
export const NewWork = () => {
  clearAllBodyScrollLocks()
  const calendarContainer = document.querySelectorAll('.calendar')[0];
	validateCalendars(calendarContainer, 0)
}